module.exports = __webpack_public_path__ + "img/623.30858891.png";